module.exports = __webpack_public_path__ + "img/logo.dece1a51.svg";